export enum ProviderCode{
    sic = 'sic',
    sicBxl = 'sicbxl',
    bbc = 'bbc2020'
}
